module.exports = __webpack_public_path__ + "media/07_maybe-one-day.6fde4983.mp3";